/** Upper bound on route params / search params per snapshot — real DMS URLs carry a handful. */
export const ASSISTANT_LOCATION_MAX_ENTRIES = 50;
